function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-facebook_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 .4C8.958.4 0 9.358 0 20.4c0 10.025 7.383 18.308 17.008 19.75V25.7h-4.95v-5.258h4.95v-3.5c0-5.792 2.825-8.334 7.634-8.334 2.308 0 3.525.175 4.1.25v4.592h-3.284c-2.041 0-2.758 1.942-2.758 4.125v2.875h5.992l-.809 5.258h-5.175V40.2C32.467 38.875 40 30.525 40 20.4c0-11.042-8.958-20-20-20z",
  fill: "#F6F6F6"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-facebook_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .4)",
  d: "M0 0h40v40H0z"
})));

function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MCA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0yMCAwLjM5OTkwMkM4Ljk1ODMzIDAuMzk5OTAyIDAgOS4zNTgyNCAwIDIwLjM5OTlDMCAzMC40MjQ5IDcuMzgzMzMgMzguNzA4MiAxNy4wMDgzIDQwLjE0OTlWMjUuNjk5OUgxMi4wNTgzVjIwLjQ0MTZIMTcuMDA4M1YxNi45NDE2QzE3LjAwODMgMTEuMTQ5OSAxOS44MzMzIDguNjA4MjQgMjQuNjQxNyA4LjYwODI0QzI2Ljk1IDguNjA4MjQgMjguMTY2NyA4Ljc4MzI0IDI4Ljc0MTcgOC44NTgyNFYxMy40NDk5SDI1LjQ1ODNDMjMuNDE2NyAxMy40NDk5IDIyLjcgMTUuMzkxNiAyMi43IDE3LjU3NDlWMjAuNDQ5OUgyOC42OTE3TDI3Ljg4MzMgMjUuNzA4MkgyMi43MDgzVjQwLjE5OTlDMzIuNDY2NyAzOC44NzQ5IDQwIDMwLjUyNDkgNDAgMjAuMzk5OUM0MCA5LjM1ODI0IDMxLjA0MTcgMC4zOTk5MDIgMjAgMC4zOTk5MDJaIiBmaWxsPSIjRjZGNkY2Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuMzk5OTAyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgIconFacebook as ReactComponent };